import { ContextMenu } from "lib/@components/context-menu-bar"

export const FolderContextMenu = ContextMenu("folder")
